let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8OH5J")).then(() => parcelRequire('jUZEM'));